export enum UserDisciplineTypeId {
  NURSE = 100,
  ALLIED = 200,
}

export enum IDisciplineId {
  PT = 14,
  PTA = 17,
}
